import Routes from './Routes.container'

export default Routes
